import { useStore, useStoreUI, useTasksStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { Split } from '../Split/Split';
import { Flex } from '../UI/Flex/Flex';
import { TaskChatPanel } from './TaskChatPanel/TaskChatPanel';
import * as style from './TaskPage.module.less';

import icon_checkmark from './icons/checkmark.svg';
import icon_circle from './icons/circle.svg';
import icon_paused from './icons/paused.svg';
import icon_working from './icons/working.svg';
import { useEffect, useState } from 'react';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { onValue, ref } from 'firebase/database';
import { ModalShowVariable } from '../ModalShowVariable/ModalShowVariable';

interface TaskPageProps {
    onClickBack?: () => void;
}

export const TaskPage = observer(({ onClickBack }: TaskPageProps) => {
    const store = useStore();
    const taskId = store.selectedTaskId || 'identify_industry';
    const taskStore = useTasksStore();
    const query = store.query;
    const active_task_id = taskId;
    const task = taskStore.get_task_definition(active_task_id);

    const [storedTasksVars, setStoredVariables] = useState(null);
    useEffect(
        function fetchTaskContent() {
            const path = `/flowtasks/vars/${reportId}`;
            const fb = getFirebase();
            const r = ref(fb.db, path);
            const unsub = onValue(r, snapshot => {
                const data = snapshot.val();
                console.log('TaskPage: fetched stored variables:', data);
                setStoredVariables(data);
            });

            return () => {
                unsub();
            };
        },
        [active_task_id]
    );

    if (!task) {
        return <div>Task not found: {active_task_id}</div>;
    }

    const reportId = store.selectedReportId;
    const tasksState = store.activeReportTasksState;
    const taskState = tasksState.getTaskQuery(active_task_id);

    const active_step = taskState.activeStep;
    const is_complete = taskState.isComplete;

    const var_exists = (storedTasksVars ?? {}).hasOwnProperty(task.save_to);
    const onShowVariable = () => {
        if (!var_exists) return;
        const uiStore = useStoreUI();
        uiStore.modal = {
            title: 'Variable: ' + task.save_to,
            el: (
                <ModalShowVariable
                    variableName={task.save_to}
                    variableValue={storedTasksVars[task.save_to]}
                />
            )
        };
    };
    const prework_vars_list = task.prerequisite_variable ?? [
        { name: '', display: 'None' }
    ];
    const prework_vars = prework_vars_list.map((var_obj, index) => {
        const is_var_ready = !taskState.isLocked;
        var icon = is_var_ready ? icon_checkmark : icon_circle;
        return (
            <Flex alignItems="center" key={'prework_' + index}>
                <img src={icon} className={style.line_icon} />
                <div className={style.line_text}>{var_obj.display}</div>
            </Flex>
        );
    });
    const inner_steps = task.inner_steps_names.map((step_name, index) => {
        const isCurrentStep = index + 1 == Number(active_step);
        const isDone = index + 1 < Number(active_step) || is_complete;

        var icon = null;
        if (isCurrentStep && !is_complete) {
            icon =
                taskState.status == 'in_progress' ? icon_working : icon_paused;
        } else {
            icon = isDone ? icon_checkmark : icon_circle;
        }

        return (
            <Flex alignItems="center" key={'step_' + index}>
                <img src={icon} className={style.line_icon} />
                <div className={style.line_text}>{step_name}</div>
            </Flex>
        );
    });

    return (
        <Split spaceBetween={0} layoutPercent={[25, 75]}>
            <Flex direction="column" fillCell={true}>
                <Flex
                    direction="column"
                    className={style.round_border_container}
                    fillCell={true}
                >
                    <div className={style.back_to_workstreams}>
                        <button
                            className={style.back_button}
                            onClick={() => {
                                if (onClickBack) onClickBack();
                            }}
                        >
                            <i
                                className="bi bi-arrow-left"
                                style={{
                                    color: 'white',
                                    fontSize: '14px',
                                    position: 'relative',
                                    top: '-1px'
                                }}
                            ></i>
                        </button>
                        Back to workstreams
                    </div>

                    <Flex direction="column" className={style.prework_list}>
                        <div className={style.inner_title}>Pre-work items</div>
                        {prework_vars}
                    </Flex>

                    <Flex direction="column" className={style.steps_list}>
                        <div className={style.inner_title}>Work items</div>
                        {inner_steps}
                    </Flex>

                    <div style={{ flexGrow: 1 }}></div>
                    <div className={style.saved_outputs}>
                        <Flex
                            fillCell={true}
                            style={{
                                padding: 5,
                                paddingTop: 8
                            }}
                        >
                            <div
                                className={style.is_var_saved}
                                onClick={() => {
                                    onShowVariable();
                                }}
                            >
                                {var_exists ? '1' : '0'}
                            </div>
                            <div style={{ flexGrow: 1 }}></div>
                            <div
                                className={style.line_text}
                                style={{ paddingRight: '3px' }}
                            >
                                Saved Outputs
                            </div>
                        </Flex>
                    </div>
                </Flex>
            </Flex>

            <TaskChatPanel taskId={active_task_id} />
        </Split>
    );
});
